/**
 * ignoreErrors: Very often, you will come across specific errors that are a result of something other than your application, or
 errors that you’re completely not interested in. ignoreErrors is a list of these messages to be filtered out before
 being sent to Sentry as either regular expressions or strings. When using strings, they’ll partially match the messages,
 so if you need to achieve an exact match, use RegExp patterns instead.
 * https://docs.sentry.io/clients/javascript/config/
 */

export const IGNORE_ERRORS_LIST = [
    '[APP_AXIOS] Error: UNAUTHORIZED - 401',
    '[APP_AXIOS] Error: FORBIDDEN - 403',

    // Network errors such as going offline or being blocked by a proxy
    /.*Failed to fetch.*/g,
    /.*Network Error.*/g,
    /.*Load failed.*/g,

    // Random plugins/extensions
    'top.GLOBALS',
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    'http://tt.epicplay.com',
    "Can't find variable: ZiteReader",
    'jigsaw is not defined',
    'ComboSearch is not defined',
    'http://loading.retry.widdit.com/',
    'atomicFindClose',
    // Facebook borked
    'fb_xd_fragment',
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
    'bmi_SafeAddOnload',
    'EBCallBackMessageReceived',
    // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    'conduitPage',

    /.*e.extra.agent.*/g,
    /.*timeout of 10000ms exceeded.*/g,
    /.*undefined is not an object (evaluating 't.default').*/g,
    /.*Cannot find module.*/g,
    /.*OneTrust: Invalid domain id.*/g,
    /.*Required token is missing.*/g,
    /.*Token Required.*/g,
    /.*code 409.*/g,
    /.*code 400.*/g,
    /.*Suspected Fraud.*/g,
    /.*Failed to execute 'insertBefore'.*/g,
    /.*__AutoFillPopupClose__.*/g,

    // solidSdk: PayPal button error (close payPal popup)
    /.*isTrusted.*/g,

    /.*undefined is not an object (evaluating 'r.DomainData').*/g,
    /.*null is not an object (evaluating 'this.selector.appendChild').*/g,
    /.*The object can not be found here.*/g,
    /.*undefined is not an object (evaluating 'e.Domain').*/g,
    /.*The object can not be cloned.*/g,
    /.*window.Zeit.setFontSize.*/g,
    /.*Can't find variable: iom.*/g,

    /.*InvalidSignatureException.*/g,
    /.*totalRetryDelay.*/g,
    /.*Can't find variable: stopYouTubeVideos.*/g,
    /.*Window closed for postrobot_method before ack.*/g,
    /.*Can't find variable: clickPauseText2SpeechButton.*/g,
    /.*Right side of assignment cannot be destructured.*/g,
    /.*Data Collector must be created with Kount and\/or PayPal.*/g,
    /.*Can't find variable: PaymentAutofillConfig.*/g,
    /.*null is not an object (evaluating 'document.getElementById('taboola_ad_script').getBoundingClientRect').*/g,
    /.*undefined is not an object (evaluating 't.Domain')*/g,
    /.*undefined is not an object (evaluating 'n.length')*/g,
    /.*Cannot read properties of undefined (reading 'domInteractive')*/g,

    // DuckDuckGo mobile 7 postMessage error
    'WKWebView API client did not respond to this postMessage',

    // Solid SDK Console Error after switching products on payment screen
    /.*Payment form iframe was removed from DOM before initialization ended*/g,

    // An error on all projects in solid-form
    /.*The object does not support the operation or argument.*/g,

    // Error from Sentry itself
    /.*Can't find variable: msDiscoverChatAvailable*/g,
];
